module.exports = __webpack_public_path__ + "img/img-11.7c6758d3.png";